import { Preferences } from '@interfaces/models/preferences';

export enum ProductFeedSource {
  PDP = 'PDP',
  HeroPDP = 'HeroPDP',
  SEMPDP = 'SEMPDP',
}

export interface ProductFeedPayload {
  locale: {
    country: Preferences['country'];
    language: Preferences['language'];
    currency: Preferences['currency'];
  };
  pagination?: {
    limit: number;
    offset: number;
  };
  options?: {
    disableSizeFilter?: boolean;
  };
  productID: number;
  source?: ProductFeedSource;
}
